import { completeAuthenticationRedirect, isAuthenticationResponse } from './common/authentication/authenticationEntry.js';

if (isAuthenticationResponse(window.location)) {
	await completeAuthenticationRedirect();
} else {
	await import('./routed/blueApp.js');
}
